"use client";

import { useState, useEffect } from "react";

export function useDateTime() {
  const [dateTime, setDateTime] = useState(null);

  useEffect(() => {
    // Set immediately on mount to avoid blank flash
    setDateTime(new Date());
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    if (!dateTime) return "";
    return dateTime.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = () => {
    if (!dateTime) return "";
    return dateTime.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const formatShortDate = () => {
    if (!dateTime) return "";
    return dateTime.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  return { dateTime, formatTime, formatDate, formatShortDate };
}
